import React, { useState, useEffect } from "react";
import { Form, Modal, Row, Col, Button, Tabs, Tab } from "react-bootstrap";
import { getUser } from "../../../services/authService";
import {
  sendFiveMReasonsToJD,
  sendFiveMBulkReasonsToJD,
  insertFiveMBookingNumber,
  insertBulkFiveMBookingNumber,
  updateFiveMBookingNumber,
  updateBulkFiveMBookingNumberWithReason,
  getFiveMDailyContainerPlanning,
  sendUpdatedFiveMReasonsToJD,
  sendBulkReasonsforhold
} from "../../../services/fiveMDataService";
import Select from "react-select";
import { toast } from "react-toastify";
import { dispatcher } from "../../../store/storeHelpers";
import {
  FIVE_M_BOOKING_DONE,
  FIVE_M_BOOKING_SENT_FOR_APPROVAL,
  FIVE_M_BOOKING_UPDATED,
  FIVE_M_BOOKING_LOADED,
} from "../../../store/ActionTypes";
import { includes } from "lodash";
import moment from "moment";
import { fiveMDataCreatorForStore } from "../../../utils/dataFilter";
function FiveMBookingModal({
  show,
  handleClose,
  data,
  reasons,
  selectedFlatRows,
  date,
  countData,
  setCountData,
  allowToHold,
  showholddialog,
  setholdmodal,
}) {
  const [shipmentData, setShipmentData] = useState({
    DailyContainerPlanning5MId: data.DailyContainerPlanning5MId,
    BookingNo: "",
    Market: data.Market,
    BookedBy: getUser().uid,
  });
  const [loading, setLoading] = useState(false);
  const [sendForApproval, setSendForApproval] = useState({});
  const [key, setKey] = useState("book");
  const [bookingReason, setBookingReason] = useState("");
  const [disableBooking, setDisableBooking] = useState(false);
  const [holdreason,setholdreason] = useState("");
  const [holdpayload,setholdpayload] = useState();
  const [step,setstep] = useState(1);


  useEffect(() => {
    setShipmentData({
      DailyContainerPlanning5MId: data.DailyContainerPlanning5MId,
      BookingNo: "",
      Market: data.Market,
      BookedBy: getUser().uid,
    });

    setholdpayload({
      dailyContainerPlanningId:
    data.DailyContainerPlanning5MId,
    reason: "",
    userId: getUser().uid,
    isHold:1,
    type:"5M",
    userId:getUser().uid,
    })
    setSendForApproval({
      DailyContainerPlanning5MId: data.DailyContainerPlanning5MId,
      AssignContainerPlanning5mId: data.AssignContainer5MId,
      Reason: "",
      manualReason: "",
      Market: data.Market,
      SendApprovalBy: getUser().uid,
    });
    if(shipmentData.BookingNo === ""){
      setDisableBooking(true)
    }
    else{
      setDisableBooking(false)
    }
  }, [data]);

  const planningId = [];

  for (let i = 0; i < selectedFlatRows.length; i++) {
    if (selectedFlatRows[i].originalSubRows.length === 0) {
      if (selectedFlatRows[i].original.Container_Count !== "") {
        if (!includes(planningId, selectedFlatRows[i].original)) {
          planningId.push(selectedFlatRows[i].original);
        }
      }
    }
  }
  if(showholddialog && step===1){
    if(showholddialog===data?.DailyContainerPlanning5MId){
       if(data?.STATUS==="Hold"){
        setstep(2);
      } 

    }
    
  }

  function showBookingLabel(counterValue) {
    let labelArray = []
    Object.keys(counterValue).map((item)=>{
      if(counterValue[item] !== 0){
        labelArray.push(item)
      }
    })
    return labelArray
  }
  function showPendingLabel(counterValue) {
    let labelArray = []
    Object.keys(counterValue).map((item)=>{
      if(counterValue[item] !== 0){
        labelArray.push(item)
      }
    })
    return labelArray
  }

  const handleTextChange = (e) => {
    setShipmentData({ ...shipmentData, [e.target.name]: e.target.value });
    if(e.target.value.length === 0){
      setDisableBooking(true)
    }else{
      setDisableBooking(false)
    }
  };

  let counterLabel = []
  let counterValue = {
    Booked: 0,
    Pending: 0,
    Approved: 0,
    Cancelled: 0,
    Not_Booked: 0,
    Hold:0,
  }

  const handleBookingDone = async () => {
    const payload = planningId.map((item) => {
      return {
        DailyContainerPlanning5MId: item.DailyContainerPlanning5MId,
        Booking_Number: shipmentData.BookingNo,
        Market: item.Market,
        Created_By: getUser().uid,
      };
    });
    try {
      setLoading(true);
      if (data.Reason || data.AssignContainer5MId) {
        if (selectedFlatRows.length === 0) {
          await updateFiveMBookingNumber({
            ...shipmentData,
            AssignContainer5MId: data.AssignContainer5MId,
          });
          dispatcher(FIVE_M_BOOKING_UPDATED, {
            ...shipmentData,
            AssignContainer5MId: data.AssignContainer5MId,
          });
        } else {
          await updateBulkFiveMBookingNumberWithReason(payload);
          const response = await getFiveMDailyContainerPlanning(
            moment(date).format("YYYY-MM-DD")
          );
          for (let i = 0; i < response.data.Resultset2.length; i++) {
						counterLabel.push(response.data.Resultset2[i]["STATUS"])
						if(response.data.Resultset2[i]["STATUS"] === "Booked"){
							counterValue.Booked = response.data.Resultset2[i]["Container_Count"]
						}
						if(response.data.Resultset2[i]["STATUS"] === "Not_Booked"){
							counterValue.Not_Booked = response.data.Resultset2[i]["Container_Count"]
						}
						if(response.data.Resultset2[i]["STATUS"] === "Pending"){
							counterValue.Pending = response.data.Resultset2[i]["Container_Count"]
						}
						if(response.data.Resultset2[i]["STATUS"] === "Approved"){
							counterValue.Approved = response.data.Resultset2[i]["Container_Count"]
						}
						if(response.data.Resultset2[i]["STATUS"] === "Cancelled"){
							counterValue.Cancelled = response.data.Resultset2[i]["Container_Count"]
						}
            if(response.data.Resultset2[i]["STATUS"] === "Hold"){
              counterValue.Hold = response.data.Resultset2[i]["Container_Count"]
            }
					}
					setCountData({label : counterLabel, counterData : counterValue})
          dispatcher(
            FIVE_M_BOOKING_LOADED,
            fiveMDataCreatorForStore(response.data.Resultset1)
          );
        }
      } else {
        if (selectedFlatRows.length === 0) {
          const apiresponse = await insertFiveMBookingNumber(shipmentData);
          dispatcher(FIVE_M_BOOKING_DONE, {
            ...shipmentData,
            AssignContainer5MId: apiresponse.data.Result,
          });
          await updateBulkFiveMBookingNumberWithReason(payload);
          const response = await getFiveMDailyContainerPlanning(
            moment(date).format("YYYY-MM-DD")
          );
          for (let i = 0; i < response.data.Resultset2.length; i++) {
						counterLabel.push(response.data.Resultset2[i]["STATUS"])
						if(response.data.Resultset2[i]["STATUS"] === "Booked"){
							counterValue.Booked = response.data.Resultset2[i]["Container_Count"]
						}
						if(response.data.Resultset2[i]["STATUS"] === "Not_Booked"){
							counterValue.Not_Booked = response.data.Resultset2[i]["Container_Count"]
						}
						if(response.data.Resultset2[i]["STATUS"] === "Pending"){
							counterValue.Pending = response.data.Resultset2[i]["Container_Count"]
						}
						if(response.data.Resultset2[i]["STATUS"] === "Approved"){
							counterValue.Approved = response.data.Resultset2[i]["Container_Count"]
						}
						if(response.data.Resultset2[i]["STATUS"] === "Cancelled"){
							counterValue.Cancelled = response.data.Resultset2[i]["Container_Count"]
						}
            if(response.data.Resultset2[i]["STATUS"] === "Hold"){
              counterValue.Hold = response.data.Resultset2[i]["Container_Count"]
            }
					}
					setCountData({label : counterLabel, counterData : counterValue})
        
        } else {
          await insertBulkFiveMBookingNumber(payload);
          const response = await getFiveMDailyContainerPlanning(
            moment(date).format("YYYY-MM-DD")
          );
          dispatcher(
            FIVE_M_BOOKING_LOADED,
            fiveMDataCreatorForStore(response.data.Resultset1)
          );
          for (let i = 0; i < response.data.Resultset2.length; i++) {
						counterLabel.push(response.data.Resultset2[i]["STATUS"])
						if(response.data.Resultset2[i]["STATUS"] === "Booked"){
							counterValue.Booked = response.data.Resultset2[i]["Container_Count"]
						}
						if(response.data.Resultset2[i]["STATUS"] === "Not_Booked"){
							counterValue.Not_Booked = response.data.Resultset2[i]["Container_Count"]
						}
						if(response.data.Resultset2[i]["STATUS"] === "Pending"){
							counterValue.Pending = response.data.Resultset2[i]["Container_Count"]
						}
						if(response.data.Resultset2[i]["STATUS"] === "Approved"){
							counterValue.Approved = response.data.Resultset2[i]["Container_Count"]
						}
						if(response.data.Resultset2[i]["STATUS"] === "Cancelled"){
							counterValue.Cancelled = response.data.Resultset2[i]["Container_Count"]
						}
            if(response.data.Resultset2[i]["STATUS"] === "Hold"){
              counterValue.Hold = response.data.Resultset2[i]["Container_Count"]
            }
					}
					setCountData({label : counterLabel, counterData : counterValue})
        }
      }
      setLoading(false);
      handleClose();
      toast.success("Booking done successfully.");
    } catch (error) {
      setLoading(false);
      if (error.response && error.response.status === 400) {
        toast.error("Error while booking please try again");
      }
    }
  };

  const handleBookingError = async () => {
    var _json5mBookingReson = [];
    try {
      if (!data.AssignContainer5MId) {
        if (selectedFlatRows.length === 0) {
          setLoading(true);
          const apiresponse = await sendFiveMReasonsToJD(sendForApproval);
          dispatcher(FIVE_M_BOOKING_SENT_FOR_APPROVAL, {
            ...sendForApproval,
            AssignContainer5MId: apiresponse.data.Result,
          });
          const response = await getFiveMDailyContainerPlanning(
            moment(date).format("YYYY-MM-DD")
          );
          for (let i = 0; i < response.data.Resultset2.length; i++) {
						counterLabel.push(response.data.Resultset2[i]["STATUS"])
						if(response.data.Resultset2[i]["STATUS"] === "Booked"){
							counterValue.Booked = response.data.Resultset2[i]["Container_Count"]
						}
						if(response.data.Resultset2[i]["STATUS"] === "Not_Booked"){
							counterValue.Not_Booked = response.data.Resultset2[i]["Container_Count"]
						}
						if(response.data.Resultset2[i]["STATUS"] === "Pending"){
							counterValue.Pending = response.data.Resultset2[i]["Container_Count"]
						}
						if(response.data.Resultset2[i]["STATUS"] === "Approved"){
							counterValue.Approved = response.data.Resultset2[i]["Container_Count"]
						}
						if(response.data.Resultset2[i]["STATUS"] === "Cancelled"){
							counterValue.Cancelled = response.data.Resultset2[i]["Container_Count"]
						}
            if(response.data.Resultset2[i]["STATUS"] === "Hold"){
              counterValue.Hold = response.data.Resultset2[i]["Container_Count"]
            }
					}
					setCountData({label : counterLabel, counterData : counterValue})
          
        } else {
          if (
            sendForApproval.Reason === "" &&
            sendForApproval.manualReason !== ""
          ) {
            for (let i = 0; i < planningId.length; i++) {
              _json5mBookingReson.push({
                DailyContainerPlanning5MId:
                  planningId[i].DailyContainerPlanning5MId,
                Reason: sendForApproval.manualReason,
                SendApprovalBy: getUser().uid,
              });
            }
          } else if (
            sendForApproval.Reason !== "" &&
            sendForApproval.manualReason !== ""
          ) {
            for (let i = 0; i < planningId.length; i++) {
              _json5mBookingReson.push({
                DailyContainerPlanning5MId:
                  planningId[i].DailyContainerPlanning5MId,
                Reason: `${sendForApproval.Reason},${sendForApproval.manualReason}`,
                SendApprovalBy: getUser().uid,
              });
            }
          } else {
            for (let i = 0; i < planningId.length; i++) {
              _json5mBookingReson.push({
                DailyContainerPlanning5MId:
                  planningId[i].DailyContainerPlanning5MId,
                Reason: sendForApproval.Reason,
                SendApprovalBy: getUser().uid,
              });
            }
          }
        }
        setLoading(true);
        await sendFiveMBulkReasonsToJD(_json5mBookingReson);
        const response = await getFiveMDailyContainerPlanning(
          moment(date).format("YYYY-MM-DD")
        );
        for (let i = 0; i < response.data.Resultset2.length; i++) {
          counterLabel.push(response.data.Resultset2[i]["STATUS"])
          if(response.data.Resultset2[i]["STATUS"] === "Booked"){
            counterValue.Booked = response.data.Resultset2[i]["Container_Count"]
          }
          if(response.data.Resultset2[i]["STATUS"] === "Not_Booked"){
            counterValue.Not_Booked = response.data.Resultset2[i]["Container_Count"]
          }
          if(response.data.Resultset2[i]["STATUS"] === "Pending"){
            counterValue.Pending = response.data.Resultset2[i]["Container_Count"]
          }
          if(response.data.Resultset2[i]["STATUS"] === "Approved"){
            counterValue.Approved = response.data.Resultset2[i]["Container_Count"]
          }
          if(response.data.Resultset2[i]["STATUS"] === "Cancelled"){
            counterValue.Cancelled = response.data.Resultset2[i]["Container_Count"]
          }
          if(response.data.Resultset2[i]["STATUS"] === "Hold"){
            counterValue.Hold = response.data.Resultset2[i]["Container_Count"]
          }
        }
        setCountData({label : counterLabel, counterData : counterValue})
        dispatcher(
          FIVE_M_BOOKING_LOADED,
          fiveMDataCreatorForStore(response.data.Resultset1)
        );
      }else{
        if (selectedFlatRows.length === 0) {
          setLoading(true);
          await sendUpdatedFiveMReasonsToJD(sendForApproval);
          dispatcher(FIVE_M_BOOKING_SENT_FOR_APPROVAL, {
            ...sendForApproval
          });
        }
      }
      setLoading(false);
      handleClose();
      toast.warn("Booking sent for approval to John deere");
    } catch (error) {
      setLoading(false);
      if (error.response && error.response.status === 400) {
        toast.error("Error while sending approval please try again");
      }
    }
  };
  const holdBooking = async () => {
    var _jsonUpdateBulkHoldStatus_AryabhattaList = [];
    if(selectedFlatRows.length === 0){
      _jsonUpdateBulkHoldStatus_AryabhattaList.push({
        ...holdpayload,
        reason:holdreason,
        isHold:step=== 1 ? 1 : 0,
      });
    }
    else{
      for (let i = 0; i < planningId.length; i++) {
        _jsonUpdateBulkHoldStatus_AryabhattaList.push({
          dailyContainerPlanningId:
                      planningId[i].DailyContainerPlanning5MId,
                    reason: holdreason,
                    userId: getUser().uid,
                    isHold:step===1 ? 1 : 0,
                    type:"5M",
                    userId:getUser().uid,
                  });
                }
    }
             if(_jsonUpdateBulkHoldStatus_AryabhattaList){
    try{
           setLoading(true) 
        const holdresponse = await sendBulkReasonsforhold(_jsonUpdateBulkHoldStatus_AryabhattaList); 
        const response = await getFiveMDailyContainerPlanning(
          moment(date).format("YYYY-MM-DD")
        );
        for (let i = 0; i < response.data.Resultset2.length; i++) {
          counterLabel.push(response.data.Resultset2[i]["STATUS"])
          if(response.data.Resultset2[i]["STATUS"] === "Booked"){
            counterValue.Booked = response.data.Resultset2[i]["Container_Count"]
          }
          if(response.data.Resultset2[i]["STATUS"] === "Not_Booked"){
            counterValue.Not_Booked = response.data.Resultset2[i]["Container_Count"]
          }
          if(response.data.Resultset2[i]["STATUS"] === "Pending"){
            counterValue.Pending = response.data.Resultset2[i]["Container_Count"]
          }
          if(response.data.Resultset2[i]["STATUS"] === "Approved"){
            counterValue.Approved = response.data.Resultset2[i]["Container_Count"]
          }
          if(response.data.Resultset2[i]["STATUS"] === "Cancelled"){
            counterValue.Cancelled = response.data.Resultset2[i]["Container_Count"]
          }
          if(response.data.Resultset2[i]["STATUS"] === "Hold"){
            counterValue.Hold = response.data.Resultset2[i]["Container_Count"]
          }
        }
        setCountData({label : counterLabel, counterData : counterValue})
        dispatcher(
          FIVE_M_BOOKING_LOADED,
          fiveMDataCreatorForStore(response.data.Resultset1)
        );
        setLoading(false)
        setholdmodal("")
        setstep(1);
        toast.success(step===1?"Booking hold successful":"Booking unhold successful")
    }
    catch(e){
     toast.error("Something went wrong")
      setLoading(false)
    }
  } 
  }

  return (
    <>
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Body>
        <Tabs
          id="controlled-tab-example"
          activeKey={key}
          onSelect={(k) => setKey(k)}
          className="mb-3"
        >
          <Tab eventKey="book" title="Book">
            <h4>Booking Done</h4>
            <Row>
              <Form.Group as={Col} className="mb-3">
                <Form.Control
                  name="BookingNo"
                  onChange={handleTextChange}
                  placeholder="enter booking no"
                />
              </Form.Group>
            </Row>
            <Button
              className="fr btn btn-sm"
              onClick={handleBookingDone}
              disabled={loading || disableBooking}
              
            >
              {loading ? "Booking" : "Book"}
            </Button>
          </Tab>
          {!data.Reason && (
            <Tab eventKey="error" title="Send for approval">
              <h4>Send for approval</h4>
              <Row>
                <Select
                  options={reasons}
                  className="form-selector mb-3"
                  getOptionLabel={(option) => option.Reason}
                  getOptionValue={(option) => option.ReasonMasterId}
                  onChange={(option) =>
                    setSendForApproval({
                      ...sendForApproval,
                      Reason: option.Reason,
                    })
                  }
                />
                <Form.Group as={Col} className="mb-3">
                  <Form.Control
                    name="BookingReason"
                    value={bookingReason}
                    onChange={(e) => {
                      setBookingReason(e.target.value);
                      setSendForApproval({
                        ...sendForApproval,
                        manualReason: e.target.value,
                      });
                    }}
                    placeholder="Enter the reason..."
                  />
                </Form.Group>
              </Row>
              <Button
                className="fr btn btn-sm"
                onClick={handleBookingError}
                disabled={loading}
              >
                {loading ? "Sending" : "Send"}
              </Button>
            </Tab>
          )}
        </Tabs>
      </Modal.Body>
    </Modal>
   <Modal  show={showholddialog===data.DailyContainerPlanning5MId} onHide={()=>{setholdmodal("")}} 
     className="DeleteModal"
     dialogClassName="deleteWidthClass"
     contentClassName="deleteHeightClass" centered>
  <Modal.Header   style={step===2 ?{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }:null}>

  {step===1 && <h4>Hold Booking</h4>}
  {step===2 && <h3>Alert</h3>}

  </Modal.Header>
      <Modal.Body>
      {step===2 && <center><h5>Do you want to unhold this plan ?</h5></center>}
            {step===1 && <Row>
              <Form.Group as={Col} className="mb-3">
                <Form.Control
                  name="Holdbooking"
                  as="textarea"
                  rows={3}
                  onChange={(e)=>setholdreason(e.target.value)}
                  placeholder="Enter the reason..."
                  maxLength={200}
                />
              </Form.Group>
            </Row>}
         { step===1 && <Button
              className="fr btn btn-sm"
              onClick={()=>holdBooking()}
              disabled={loading || !holdreason}
            >
             { loading ? "Holding..": "Hold"}
            </Button>
            }

            {
              step==2 && 
              <div className="DeleteModal__Btn">
           
                <Button
       className="DeleteModal__noBtn"
              onClick={()=>setholdmodal("")}
              disabled={loading}

             
            >
             {"No"}
            </Button>
            <Button
               className="DeleteModal__yesBtn"
              onClick={()=>holdBooking()}
              disabled={loading}
        
            >
             {"Yes"}
            </Button>
            </div>
            }
      </Modal.Body>
    </Modal>

    </>
  );
}

export default FiveMBookingModal;
